import { Order } from '#/unified-rfqs/entities/drfq/orders';
import EntityStore from './entity';

export class DrfqOrdersStore {
  private readonly rfqOrders = new Map<string, EntityStore<Order>>();

  byRfq(rfqId: string) {
    let orders = this.rfqOrders.get(rfqId);
    if (orders == null) {
      orders = new EntityStore<Order>();
      this.rfqOrders.set(rfqId, orders);
    }
    return orders;
  }

  clearByRfq(rfqId: string) {
    const orders = this.rfqOrders.get(rfqId);
    orders?.clear();
    this.rfqOrders.delete(rfqId);
  }

  clear() {
    for (const orders of this.rfqOrders.values()) {
      orders.clear();
    }
    this.rfqOrders.clear();
  }
}
